
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { href: "#hero", label: "Home" },
    { href: "#features", label: "Features" },
    { href: "/auth", label: "Sign Up" },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 py-3 px-4 md:px-8 
        ${scrolled ? 'bg-zinc-900/95 backdrop-blur-sm border-b border-green-500/20' : 'bg-zinc-900/80 backdrop-blur-sm'}`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center mr-4">
            <img 
              src="/lovable-uploads/66d430f8-b599-4238-a7c4-35acca049451.png" 
              alt="Weirdobeach Logo" 
              className="h-8 w-8 mr-2"
            />
            <span className="text-green-500 text-2xl font-bold glitch-text">
              W<span className="text-red-500">_</span>eirdobeach
            </span>
          </Link>
          <span className="hidden md:inline-block text-green-400 text-xs analog-text ml-2">
            v2.0.1/Cosmic_Protocol
          </span>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          {navItems.map((item) => (
            <a 
              key={item.href}
              href={item.href} 
              className="text-gray-400 hover:text-green-500 hover-glitch transition-colors text-sm analog-text"
            >
              {item.label}
            </a>
          ))}
          <Button 
            variant="outline" 
            className="bg-transparent border border-green-500 text-green-500 hover:bg-green-500/10 ml-4"
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </Button>
        </nav>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-green-500 p-2 border border-green-500/30 hover:border-green-500 transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <div className="w-5 h-5 flex flex-col justify-between">
            <span className={`block h-0.5 bg-current transition-transform ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`block h-0.5 bg-current transition-opacity ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block h-0.5 bg-current transition-transform ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </div>
        </button>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-zinc-900/95 backdrop-blur-sm border-b border-green-500/20 md:hidden">
            <nav className="px-4 py-6 space-y-4">
              {navItems.map((item) => (
                <a 
                  key={item.href}
                  href={item.href} 
                  className="block text-gray-400 hover:text-green-500 hover-glitch transition-colors analog-text"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <Button 
                variant="outline" 
                className="w-full bg-transparent border border-green-500 text-green-500 hover:bg-green-500/10 mt-4"
                onClick={() => {
                  navigate('/dashboard');
                  setMobileMenuOpen(false);
                }}
              >
                Dashboard
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
